"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _reactDom = require("react-dom");

var _immutable = _interopRequireDefault(require("immutable"));

var _I18n = _interopRequireDefault(require("I18n"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UICloseButton = _interopRequireDefault(require("UIComponents/button/UICloseButton"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _resize = _interopRequireDefault(require("FileManagerCore/utils/resize"));

var _Constants = require("FileManagerCore/Constants");

var _image = require("FileManagerCore/utils/image");

var _file = require("FileManagerCore/utils/file");

var _fileSize = require("FileManagerCore/utils/fileSize");

var _VideoPlayer = require("FileManagerCore/components/VideoPlayer");

var _DeleteFileContainer = _interopRequireDefault(require("FileManagerLib/components/containers/DeleteFileContainer"));

var _MoveButton = _interopRequireDefault(require("FileManagerLib/components/browser/MoveButton"));

var _EditButton = _interopRequireDefault(require("FileManagerLib/components/EditButton"));

var _Filename = _interopRequireDefault(require("FileManagerLib/components/browser/Filename"));

var _ImageOptimizationControl = _interopRequireDefault(require("FileManagerLib/components/controls/ImageOptimizationControl"));

var _getIsFileOptimizableImage = _interopRequireDefault(require("FileManagerLib/utils/getIsFileOptimizableImage"));

var WIDTH = 380;
var ARROW_WIDTH = 16;

var FileDetail =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(FileDetail, _Component);

  function FileDetail(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FileDetail);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FileDetail).call(this, props));
    _this.handleInsert = _this.handleInsert.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleMove = _this.handleMove.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleRename = _this.handleRename.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateHeight = _this.updateHeight.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleCloseButtonClick = _this.handleCloseButtonClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FileDetail, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.startMutationObserver();
      this.updateHeight();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopMutationObserver();
    }
  }, {
    key: "getDimensions",
    value: function getDimensions() {
      var tile = this.props.tile;
      var file = tile.get('file');

      if (!file.get('width') || !file.get('height')) {
        return null;
      }

      return file.get('width') + " x " + file.get('height') + " px";
    }
  }, {
    key: "getSize",
    value: function getSize() {
      var tile = this.props.tile;
      var file = tile.get('file');
      return (0, _fileSize.fileSize)(file.get('size'));
    }
  }, {
    key: "getImageSrc",
    value: function getImageSrc(file) {
      var url = file.get('url');

      if (file.has('tempUrl')) {
        return file.get('tempUrl');
      }

      if (file.has('progress')) {
        return url;
      }

      url = url + "?t=" + file.get('updated');

      if (file.get('replaced')) {
        return url;
      }

      return (0, _resize.default)(url, {
        width: WIDTH * 2
      });
    }
  }, {
    key: "startMutationObserver",
    value: function startMutationObserver() {
      var wrapperNode = (0, _reactDom.findDOMNode)(this.wrapper);
      var _window = window,
          MutationObserver = _window.MutationObserver;

      if (!MutationObserver) {
        return;
      }

      this.observer = new MutationObserver(this.updateHeight);
      this.observer.observe(wrapperNode, {
        attributes: true,
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "stopMutationObserver",
    value: function stopMutationObserver() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }, {
    key: "updateHeight",
    value: function updateHeight() {
      var _this$props = this.props,
          tile = _this$props.tile,
          onUpdateHeight = _this$props.onUpdateHeight;
      var file = tile.get('file');
      var wrapperNode = (0, _reactDom.findDOMNode)(this.wrapper);
      var height = wrapperNode.clientHeight;

      if (tile.get('height') !== height) {
        onUpdateHeight(file, height);
      }
    }
  }, {
    key: "handleCloseButtonClick",
    value: function handleCloseButtonClick() {
      var onClose = this.props.onClose;
      onClose({
        target: 'close-button'
      });
    }
  }, {
    key: "handleInsert",
    value: function handleInsert() {
      var _this$props2 = this.props,
          tile = _this$props2.tile,
          onClose = _this$props2.onClose,
          onInsert = _this$props2.onInsert;
      var file = tile.get('file');
      onClose({
        target: 'insert-file'
      });
      onInsert(file);
    }
  }, {
    key: "handleMove",
    value: function handleMove(folder) {
      var _this$props3 = this.props,
          tile = _this$props3.tile,
          onMove = _this$props3.onMove;
      var file = tile.get('file');
      onMove(file, folder);
    }
  }, {
    key: "handleRename",
    value: function handleRename(newName) {
      var _this$props4 = this.props,
          tile = _this$props4.tile,
          onRename = _this$props4.onRename;
      var file = tile.get('file');
      onRename(file, newName);
    }
  }, {
    key: "renderArrow",
    value: function renderArrow(tile) {
      var arrowX = tile.get('arrowX');
      return _react.default.createElement("div", {
        className: "file-detail__arrow",
        style: {
          left: arrowX - ARROW_WIDTH * 0.5
        }
      });
    }
  }, {
    key: "renderVideoPlayer",
    value: function renderVideoPlayer(file) {
      return _react.default.createElement(_VideoPlayer.VideoPlayer, {
        className: "m-bottom-4",
        video: file,
        width: WIDTH
      });
    }
  }, {
    key: "renderImage",
    value: function renderImage(file) {
      var dimensions = (0, _image.scaleToFit)(file, WIDTH);
      return _react.default.createElement("div", {
        className: "justify-center"
      }, _react.default.createElement("div", {
        className: "file-detail__image-wrapper image__transparency-checkboard m-bottom-4",
        style: (0, _extends2.default)({}, dimensions)
      }, (0, _image.isShutterstock)(file) && _react.default.createElement("div", {
        className: "file-detail__image-overlay"
      }), _react.default.createElement(_UIImage.default, (0, _extends2.default)({
        className: "file-detail__image",
        src: this.getImageSrc(file),
        responsive: false,
        draggable: false
      }, dimensions))));
    }
  }, {
    key: "renderFile",
    value: function renderFile(file) {
      switch (file.get('type')) {
        case _Constants.FileTypes.MOVIE:
          return this.renderVideoPlayer(file);

        case _Constants.FileTypes.IMG:
          return this.renderImage(file);

        default:
          return null;
      }
    }
  }, {
    key: "renderInsertButton",
    value: function renderInsertButton(file) {
      var disableInsert = file.get('notSupported');

      var button = _react.default.createElement(_UIButton.default, {
        use: "primary",
        onClick: this.handleInsert,
        disabled: disableInsert
      }, _I18n.default.text('FileManagerLib.actions.insert'));

      if (disableInsert) {
        return _react.default.createElement(_UITooltip.default, {
          title: file.get('notSupportedReason')
        }, button);
      }

      return button;
    }
  }, {
    key: "renderImageOptimizationControl",
    value: function renderImageOptimizationControl() {
      return _react.default.createElement(_Small.default, {
        use: "help"
      }, _react.default.createElement(_ImageOptimizationControl.default, null));
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          tile = _this$props5.tile,
          onDelete = _this$props5.onDelete,
          parentFolder = _this$props5.parentFolder,
          folderCount = _this$props5.folderCount,
          hasDirectFileLinkAccess = _this$props5.hasDirectFileLinkAccess,
          isUngatedForImageOptimization = _this$props5.isUngatedForImageOptimization;
      var file = tile.get('file');
      var dimensions = this.getDimensions();
      return _react.default.createElement("div", {
        ref: function ref(c) {
          _this2.wrapper = c;
        },
        className: "file-detail"
      }, this.renderArrow(tile), _react.default.createElement("div", {
        className: "file-detail__wrapper"
      }, _react.default.createElement(_UICloseButton.default, {
        className: "file-detail__close-button",
        size: "medium",
        onClick: this.handleCloseButtonClick
      }), _react.default.createElement(_Filename.default, {
        file: file,
        onUpdate: this.handleRename
      }), this.renderFile(file), _react.default.createElement(_UIList.default, {
        className: "file-detail__meta m-bottom-4"
      }, dimensions && _react.default.createElement(_Small.default, {
        use: "help"
      }, _I18n.default.text('FileManagerLib.fileDetail.dimensions', {
        dimensions: dimensions
      })), _react.default.createElement(_Small.default, {
        use: "help"
      }, _I18n.default.text('FileManagerLib.fileDetail.type', {
        type: file.get('extension')
      })), _react.default.createElement(_Small.default, {
        use: "help"
      }, _I18n.default.text('FileManagerLib.fileDetail.size', {
        size: this.getSize()
      })), isUngatedForImageOptimization && (0, _getIsFileOptimizableImage.default)(file) && this.renderImageOptimizationControl()), _react.default.createElement("div", {
        className: "m-bottom-5"
      }, folderCount > 0 && _react.default.createElement(_MoveButton.default, {
        size: "extra-small",
        folder: parentFolder,
        onMove: this.handleMove
      }), file.get('type') === _Constants.FileTypes.IMG && (0, _image.isEditableImage)(file) && _react.default.createElement(_EditButton.default, {
        openedFrom: _Constants.ImageEditorLocations.DRAWER,
        size: "extra-small",
        file: file
      }), _react.default.createElement(_DeleteFileContainer.default, {
        file: file,
        onDelete: onDelete
      })), _react.default.createElement("div", null, this.renderInsertButton(file), (0, _file.getShouldRenderFileUrl)({
        file: file,
        hasDirectFileLinkAccess: hasDirectFileLinkAccess
      }) && _react.default.createElement(_UILink.default, {
        className: "m-left-6",
        href: file.get('url'),
        external: true
      }, _I18n.default.text('FileManagerCore.actions.openLink')))));
    }
  }]);
  return FileDetail;
}(_react.Component);

FileDetail.propTypes = {
  tile: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
  folderCount: _react.PropTypes.number.isRequired,
  parentFolder: _react.PropTypes.instanceOf(_immutable.default.Map).isRequired,
  onInsert: _react.PropTypes.func.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  onDelete: _react.PropTypes.func.isRequired,
  onMove: _react.PropTypes.func.isRequired,
  onRename: _react.PropTypes.func.isRequired,
  onUpdateHeight: _react.PropTypes.func.isRequired,
  hasDirectFileLinkAccess: _react.PropTypes.bool.isRequired,
  isUngatedForImageOptimization: _react.PropTypes.bool.isRequired
};
var _default = FileDetail;
exports.default = _default;
module.exports = exports.default;